import I18n from 'app/i18n';
import {userStore} from 'app/store/global';

export const dateLabel = (): string => `${I18n.t('date_label')} (${userStore.user.time_zone.name})`;
